// removed by extract-text-webpack-plugin
module.exports = {"section":"section__3BExH","mt100":"mt100__13o0I","or":"or__1Jios","elss-graph":"elss-graph__cWT3E","legend":"legend__3GZkK","elss-columns":"elss-columns___jdQh","elss-card":"elss-card__1Krx0","legend-container":"legend-container__9VPh4","line-height":"line-height__1blKI","graph-point":"graph-point__1-6tE","spacer":"spacer__2YCNv","mobile-subtitle":"mobile-subtitle__2lLE0","mt30":"mt30__1SBwU"};


//////////////////
// WEBPACK FOOTER
// ./styles/home/section.scss
// module id = 492
// module chunks = 68